export function isEmail(potentialEmail?: string): boolean {
	if (!potentialEmail) {
		return false;
	}
	const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
	return emailRegex.test(potentialEmail);
}
